<template>
  <SectionContentRedFlagContent v-bind="props" />
</template>

<script setup>
const props = defineProps({
  badgeNumber: {
    type: String,
    default: '2'
  },
  badgeText: {
    type: String,
    default: 'Red Flag No. 2'
  },
  title: {
    type: String,
    default: 'The Male Brain Crisis No One Talks About (But Every Man Feels)'
  },
  introContent: {
    type: String,
    default: `<p>Men experience faster age-related cognitive decline than women.</p>
<p>Memory. Processing speed. Spatial skills.</p>
<p>All decline earlier and more sharply.</p>
<p>But studies show:</p>`
  },
  stainImageSrc: {
    type: String,
    default: ''
  },
  calloutIcon: {
    type: String,
    default: ''
  },
  calloutTitle: {
    type: String,
    default: 'Studies have shown regular coffee drinkers have:'
  },
  calloutContent: {
    type: String,
    default: `<ul>
  <li>29% lower risk of Parkinson's</li>
  <li>28% lower risk of dementia</li>
  <li>Better reaction time, attention, and learning</li>
  <li>Stronger short- and long-term memory <sup>15</sup></li>
</ul>`
  },
  calloutAsideImageSrc: {
    type: String,
    default: ''
  },
  calloutAsideImageAlt: {
    type: String,
    default: ''
  },
  showCalloutAsidePlaceholder: {
    type: Boolean,
    default: false
  },
  outroContent: {
    type: String,
    default: `<p>A 2020 study in Nutrients found that caffeine increases brain connectivity and improves executive function.</p>
<p>Another study in <em>The Journal of Alzheimer's Disease</em> found that coffee's polyphenols help reduce amyloid-beta accumulation — a key factor in Alzheimer's.</p>
<p>And when you combine clean coffee with functional ingredients like lion's mane, chaga, coffee-fruit extract, and Alpha-GPC?</p>
<p>You get a daily ritual that is shown to actively support BDNF (brain-derived neurotrophic factor), neural resilience, and cognitive performance.<sup>16</sup></p>
<p><strong class="text-[20px] text-[#3B2314]">Mindflow, Cognition Coffee, Regular Coffee</strong></p>
<p>Call it the Lifeboost brain health trifecta, call it delicious, call it a part of your daily routine…I call it a delicious brain biohack!</p>
<p>Each of these products are truly powerful ways to support the health of your brain.</p>`
  },
  showDivider: {
    type: Boolean,
    default: false
  },
  paddingBottom: {
    type: String,
    default: 'default'
  },
  paddingTop: {
    type: String,
    default: 'default'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Red Flag Brain Health',
  inputs: [
    {
      name: 'badgeNumber',
      type: 'text',
      defaultValue: '2'
    },
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: 'Red Flag No. 2'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'The Male Brain Crisis No One Talks About (But Every Man Feels)'
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: `<p>Men experience faster age-related cognitive decline than women.</p>
<p>Memory. Processing speed. Spatial skills.</p>
<p>All decline earlier and more sharply.</p>
<p>But studies show:</p>`
    },
    {
      name: 'stainImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: ''
    },
    {
      name: 'calloutIcon',
      type: 'text',
      enum: ['', 'coffee', 'alert'],
      defaultValue: ''
    },
    {
      name: 'calloutTitle',
      type: 'text',
      defaultValue: 'Studies have shown regular coffee drinkers have:'
    },
    {
      name: 'calloutContent',
      type: 'richText',
      defaultValue: `<ul>
  <li>29% lower risk of Parkinson's</li>
  <li>28% lower risk of dementia</li>
  <li>Better reaction time, attention, and learning</li>
  <li>Stronger short- and long-term memory <sup>15</sup></li>
</ul>`
    },
    {
      name: 'calloutAsideImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: ''
    },
    {
      name: 'calloutAsideImageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'showCalloutAsidePlaceholder',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: `<p>A 2020 study in Nutrients found that caffeine increases brain connectivity and improves executive function.</p>
<p>Another study in <em>The Journal of Alzheimer's Disease</em> found that coffee's polyphenols help reduce amyloid-beta accumulation — a key factor in Alzheimer's.</p>
<p>And when you combine clean coffee with functional ingredients like lion's mane, chaga, coffee-fruit extract, and Alpha-GPC?</p>
<p>You get a daily ritual that is shown to actively support BDNF (brain-derived neurotrophic factor), neural resilience, and cognitive performance.<sup>16</sup></p>
<p><strong class="text-[20px] text-[#3B2314]">Mindflow, Cognition Coffee, Regular Coffee</strong></p>
<p>Call it the Lifeboost brain health trifecta, call it delicious, call it a part of your daily routine…I call it a delicious brain biohack!</p>
<p>Each of these products are truly powerful ways to support the health of your brain.</p>`
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    }
  ]
})
</script>
